import React from 'react';
import { Input, InputProps } from 'semantic-ui-react';

interface PercentFieldProps extends Omit<InputProps, 'onChange'> {
	onChange?: (event: React.ChangeEvent<HTMLInputElement>, data: any) => void;
	setData: (value: string) => void;
	value: string;
}

const PercentField: React.FC<PercentFieldProps> = ({
	onChange,
	setData,
	value,
	...props
}) => {
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>, data: any) => {
		// Clean and validate the input value
		let newValue = data.value.replace(/[^\d.]/g, '');

		// Ensure only one decimal point
		const decimalCount = (newValue.match(/\./g) || []).length;
		if (decimalCount > 1) {
			newValue = newValue.replace(/\.(?=.*\.)/g, '');
		}

		// Limit to two decimal places
		const parts = newValue.split('.');
		if (parts[1] && parts[1].length > 2) {
			newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
		}

		// Limit to 100 or less
		const numValue = parseFloat(newValue);
		if (!isNaN(numValue) && numValue > 100) {
			newValue = '100';
		}

		// Update the data object with the cleaned value
		const cleanedData = {
			...data,
			value: newValue,
		};

		// Call setData with the cleaned value
		setData(newValue);

		// Call the original onChange if provided
		if (onChange) {
			onChange(e, cleanedData);
		}
	};

	return (
		<Input
			{...props}
			label={'%'}
			fluid
			placeholder={'0.00'}
			onChange={(e, data) => handleChange(e, data)}
			value={value}
		/>
	);
};

export default PercentField;
